import { beforeEnter } from '@/views/contratos-originacao/parametros/utils/router';

const routes = [
    {
        path: '/parametros/padrao',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                /* webpackChunkName: "configuracao-parametros" */
                '@/views/contratos-originacao/parametros/views/pages/ConfiguracaoParametros.vue'
            ),
        children: [
            {
                path: '',
                name: 'ConfiguracaoParametros',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter,
                component: () =>
                    import(
                        /* webpackChunkName: "configuracao-parametros-padrao" */
                        '@/views/contratos-originacao/parametros/views/pages/parametros-padrao/ParametrosPadrao.vue'
                    )
            },
            {
                path: '/parametros/estado',
                name: 'ParametrosEstado',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter,
                component: () =>
                    import(
                        /* webpackChunkName: "configuracao-parametros-estado" */
                        '@/views/contratos-originacao/parametros/views/pages/parametros-estado/ParametrosEstado.vue'
                    )
            },
            {
                path: '/parametros/fornecedor',
                name: 'ParametrosFornecedor',
                meta: {
                    roles: [
                        'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                        'ROLE_ADMINISTRATOR'
                    ]
                },
                beforeEnter,
                component: () =>
                    import(
                        /* webpackChunkName: "configuracao-parametros-fornecedor" */
                        '@/views/contratos-originacao/parametros/views/pages/parametros-fornecedor/ParametrosFornecedor.vue'
                    )
            }
        ]
    },
    {
        path: '/parametros/padrao/formulario/:idConfiguracaoRastreabilidade?',
        name: 'ParametrosPadraoFormulario',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                /* webpackChunkName: "configuracao-parametros-padrao-formulario" */
                '@/views/contratos-originacao/parametros/views/pages/parametros-padrao/ParametrosPadraoFormulario.vue'
            )
    },
    {
        path: '/parametros/estado/formulario/:idConfiguracaoRastreabilidade?',
        name: 'ParametrosEstadoFormulario',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                /* webpackChunkName: "configuracao-parametros-estado-formulario" */
                '@/views/contratos-originacao/parametros/views/pages/parametros-estado/ParametrosEstadoFormulario.vue'
            )
    },
    {
        path: '/parametros/fornecedor/formulario/:idConfiguracaoRastreabilidade?',
        name: 'ParametrosFornecedorFormulario',
        props: true,
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                /* webpackChunkName: "configuracao-parametros-fornecedor-formulario" */
                '@/views/contratos-originacao/parametros/views/pages/parametros-fornecedor/ParametrosFornecedorFormulario.vue'
            )
    },
    {
        path: '/parametros/fornecedor/visualizar/:idConfiguracaoRastreabilidade?',
        name: 'ParametrosFornecedorDetalhes',
        props: true,
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                /* webpackChunkName: "configuracao-parametros-fornecedor-visualizar" */
                '@/views/contratos-originacao/parametros/views/pages/parametros-fornecedor/ParametrosFornecedorDetalhes.vue'
            )
    }
];

export default routes;
